import { InspectionFormData } from '@/types/inspection-form';

/**
 * Create initial form data with empty/default values
 */
export function createInitialFormData(registeredOwnerName: string = ''): InspectionFormData {
  return {
    // Owner verification
    registeredOwnerName,
    detectedOwnerName: '',
    ownershipNotice: {
      value: '',
      media: [],
    },

    // Road condition (type + rating)
    roadCondition: {
      type: '',
      rating: 0,
    },

    // Weather (just value)
    weather: '',

    // DataWithMedia fields
    drainStatus: {
      value: '',
      media: [],
    },
    vegetationStatus: {
      value: '',
      media: [],
    },
    waterloggedStatus: {
      value: '',
      media: [],
    },
    wasteDumping: {
      value: '',
      media: [],
    },
    constructionActivity: {
      value: '',
      media: [],
    },

    // Pure media arrays
    mainAccessPoint: [],
    siteOverview: [],

    // Flagged issues
    issues: [],
  };
}
